export default __webpack_public_path__ + "static/media/runnerup1.107b8ab5.jpg";